import { CommonContentContext } from '@/utils/context/commonContent/CommonContentContext';
import { Popconfirm } from 'antd';
import { useRouter } from 'next/router';
import React, { useContext } from 'react';

export const GoBackButton: React.FC<{
  url?: string;
  disabled?: boolean;
  popConfirm?: boolean;
  title?: string;
}> = (props) => {
  const router = useRouter();
  const { backButtonConfig } = useContext(CommonContentContext);

  const url = props.url ?? backButtonConfig.url;
  const disabled = props.disabled ?? backButtonConfig.disabled ?? false;
  const popConfirm = props.popConfirm ?? backButtonConfig.popConfirm ?? false;
  const title = props.title ?? backButtonConfig.title;

  const handleBack = () => {
    if (url) {
      router.push(`/${url}`);
    } else if (router.query.returnTo) {
      router.push(`/${router.query.returnTo}`);
    } else {
      router.back();
    }
  };

  if (popConfirm) {
    return (
      <Popconfirm
        disabled={disabled}
        placement="topLeft"
        okButtonProps={{ style: { backgroundColor: 'blue' } }}
        title={title}
        description={
          <p className="max-w-[160px]">Are you sure? Exiting this page will make you lose any unsaved changes.</p>
        }
        okText="Yes"
        cancelText="No"
        onConfirm={handleBack}
      >
        <button
          className="goBackButton grid h-11 w-11 place-items-center rounded-xl border border-[#d6ded6] bg-white"
          type="button"
          aria-label="Back"
        >
          <svg
            className="h-[18px] w-[18px]"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
      </Popconfirm>
    );
  }

  return (
    <button
      className="grid h-11 w-11 place-items-center rounded-xl border border-[#d6ded6] bg-white"
      type="button"
      aria-label="Back"
      onClick={handleBack}
      disabled={disabled}
    >
      <svg
        className="h-[18px] w-[18px]"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </button>
  );
};
